import { defineEffect } from '../../../core/effect';

/**
 * **ドロー**（Issue #537）。デッキから手札へ。
 *
 * 開く: `draw`。デッキの位置でカードが光って持ち上がり、手札へ向かって薄れる。
 *
 * **実写の Field は手札のゾーンを知らない**（`overlay_zones` に無い）ので、
 * 行き先が引けないときは `else` でデッキの位置に落とす（何も出ないより良い）。
 */
export default defineEffect({
  situation: 'draw',
  label: 'ドロー',
  color: '#8fd7ff',
  sounds: () => [{ at: 0, name: 'draw' }],

  opens({ payload }) {
    // 引いた枚数ぶん来る（`cards`）。分からなければ 1 枚ぶんだけ出す
    const cards = payload?.cards?.length ? payload.cards : [{ uid: payload?.uid ?? null, code: payload?.code ?? null, zone: payload?.zone ?? null }];
    return { ...payload, cards };
  },

  layers: [
    {
      id: 'card',
      label: 'カード',
      part: 'card',
      for: 'cards',
      at: { zone: 'maindeck:{player}', else: { screen: [960, 700] } },
      props: { code: '{code}', player: '{player}', faceUp: false },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.5 }, { ms: 220, value: 1, ease: 'ease_out' }, { ms: 620, value: 0.8 }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 140, value: 1 }, { ms: 520, value: 1 }, { ms: 620, value: 0 }] },
        y: { keys: [{ ms: 0, value: 0 }, { ms: 620, value: -120, ease: 'ease_out' }] },
      },
    },
    {
      id: 'flash',
      label: 'デッキの光',
      part: 'glow',
      at: { zone: 'maindeck:{player}', else: { screen: [960, 700] } },
      props: { color: '#8fd7ff' },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.8 }, { ms: 240, value: 1.8, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0.9 }, { ms: 300, value: 0 }] },
      },
    },
  ],
}, 'draw_effect.js');
